import React from 'react'
import DOMPurify from 'dompurify'

function BlogQuote({ quote = '', title = '', subTitle = '' }) {
  return (
    <div className="BlogQuote outerContainer u-posRelative u-sizeFull u-sizeConstrained u-sizeConstrainedNarrow u-sm-transformUp50 u-marginBottom6gu">
      <div className="full-height u-flex u-flexCol u-flexJustifyCenter u-flexAlignItemsStart">
        <div className="u-flex u-sizeFull u-flexJustifyStart"></div>
        <div className="u-flex u-flexCol u-flexAlignItemsStart u-size3of4 u-sm-sizeFull u-paddingVert8gu u-sm-paddingVert4gu u-md-paddingVert4gu u-paddingLeft8gu u-borderLeftBrandLight">
          <span className="Icon--material material-icons Icon--material-quote u-posRelative u-textSizeMsrp7 u-marginBottom3gu">
            format_quote
          </span>
          <h2 className="u-marginBottom6gu u-textNormal u-textOpen u-textPrimary u-textNoTransform">
            {quote}
          </h2>
          <h3 className="u-textColorBrand u-textBold u-textPrimary">{title}</h3>
          <div
            className="Content"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subTitle) }}
          ></div>
        </div>
      </div>
    </div>
  )
}

export { BlogQuote }
